import { useAppNavigate } from '@insurance/hooks'
import { paths } from '@insurance/routes'
import { Text } from '@shared/components'
import { Alert, Button, Col, Form } from 'antd'
import { useTranslation } from 'react-i18next'

import { useHealthInsuranceValues } from './HealthInsuranceContext'
import { useStyles } from './styles'

export const AlertModifyInsurance = () => {
  const { t } = useTranslation()
  const navigate = useAppNavigate()
  const { order } = useHealthInsuranceValues()
  const { styles } = useStyles()

  const orderPrice = Form.useWatch('order_price', { preserve: true })
  const price = Form.useWatch('price', { preserve: true })

  const id = order?.id
  const showMessage = !price?.amount || price?.amount > orderPrice?.amount

  if (!id || showMessage) return null

  return (
    <Col span={24}>
      <Alert
        showIcon
        type="error"
        message={
          <Text strong size={16}>
            {t('alert_message_to_reject')}{' '}
            <Button
              type="link"
              className={styles.buttonLink}
              onClick={() =>
                navigate(paths.salesPanel.healthInsurance.reject(id))
              }
            >
              {t('termination').toLowerCase()}
            </Button>
          </Text>
        }
      />
    </Col>
  )
}
